import { IoAlertCircleOutline } from 'react-icons/io5';

import { Modal } from '@/components';
import { ButtonOutlinedErrorSmall, ButtonOutlinedSmall } from '@/components/Button';

import styles from './ConfirmationModal.module.scss';

interface ConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
}

const ConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Delete',
  cancelText = 'Cancel',
}: ConfirmationModalProps) => {
  return (
    <Modal open={open} onClose={onClose} title={title} size="full">
      <div className={styles.deleteModalContent}>
        <p className={styles.deleteIconLabel}>
          <IoAlertCircleOutline />
        </p>
        <p className={styles.deleteText}>{message}</p>
        <div className={styles.deleteButtons}>
          <ButtonOutlinedErrorSmall
            type="button"
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            {confirmText}
          </ButtonOutlinedErrorSmall>
          <ButtonOutlinedSmall type="button" onClick={onClose}>
            {cancelText}
          </ButtonOutlinedSmall>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
